import { useInvoicesQuery } from './invoices.generated';
import { sortByProperty, useParameters } from '@web/utils/src';
import { InvoiceStatuses } from '@web/utils/src/components/InvoiceStatus/InvoiceStatus';
import { Invoice, Sort } from '@/types';
import InvoicesTable from './components/InvoicesTable';

type PInvoice = Pick<
  Invoice,
  'id' | 'paymentOptions' | 'totalGross' | 'issuedAt'
> & {
  status: InvoiceStatuses;
};

const InvoicesPage: React.FC = () => {
  const { retailerId } = useParameters<{ retailerId: string }>();
  const [{ data }] = useInvoicesQuery({
    variables: {
      filter: {
        retailerID: retailerId,
      },
      sort: {
        issuedAt: Sort.Desc,
      },
    },
  });

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const invoices = sortByProperty(
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (data?.currentUser?.invoicesConnection.edges || [])
      .filter((i) => !!i.node)
      .map((i) => i.node) as PInvoice[], // needed as filter is not typesafe
    'issuedAt',
    Sort.Desc,
  );

  return <InvoicesTable invoiceList={invoices} />;
};

export default InvoicesPage;
